import React from 'react'

export const IconCencoPrime = () => {
    return (
        <>
        <span style={{ marginLeft: '5px', marginRight: '5px', fontSize: '20px'}}>
            <span className="icon-ic-prime">
                <span className="path1"></span>
                <span className="path2"></span>
            </span>
        </span>     
        </>
    )
}
